/**
 * Get project path (string) from projectDir
 * @param projectDir - The project directory (string path or FileSystemDirectoryHandle)
 * @param isElectron - Whether running in Electron
 * @param projectId - The project ID
 * @param getStoredProjectPath - Function to get stored project path from context
 * @returns The project path as a string, or null if not available
 */
export function getProjectPath(
  projectDir: string | FileSystemDirectoryHandle | null,
  isElectron: boolean,
  projectId: string | null,
  getStoredProjectPath: (projectId: string) => string | null
): string | null {
  if (typeof projectDir === 'string') {
    return projectDir;
  }
  if (isElectron && projectId) {
    return getStoredProjectPath(projectId);
  }
  return null;
}
